'use strict';

const getAuthToken = require('./get-auth-token');
const urlJoin = require('url-join');
const q = require('q');
const { post } = require('../send-action');

const authenticate = (options = {}) => {
  const [userId, authToken, expires, employeeId] = getAuthToken(options.location);
  let ssoUrl;
  const payload = {
    auth_token: authToken,
    expires,
  };

  if (employeeId) {
    payload.employee_id = employeeId;
  }

  if (!(userId && authToken && expires)) {
    return q.reject({
      error: 'Missing auth_token or expires parameters',
      auth_token: authToken,
      expires,
    });
  }

  ssoUrl = urlJoin(options.baseUrl, 'pb/users', userId, 'sso_login/');

  return post(ssoUrl, payload);
};

module.exports = authenticate;
